import { ToggleActivityStateFilter } from "components/filters/ToggleActivityStateFilter";
import React from "react";
import { Filter } from 'react-admin';

import TextInputEx from "../../../components/_extensions/react-admin/input/TextInputEx";
import { parseDigitsAndLetters } from '../../../components/_helpers/parsers';
import { CompanySelect } from '../../../components/inputs/CompanySelect';

export const TrailersFilter = ({ companySource, hasCompanyFilter, ...props }) => (
	<Filter {...props}>
		<ToggleActivityStateFilter source="activity_state" defaultValue={null} alwaysOn key={"activity_state"}/>
		{hasCompanyFilter && <CompanySelect source="company_id" reference="companies" />}
		<TextInputEx source="name" parse={parseDigitsAndLetters(1, 10)} />
	</Filter>
);
